import * as React from 'react';
import * as autoBind from 'react-autobind';
import ValuePropModal from '../ValuePropModal/ValuePropModal';
import Strings from '../../globals/Strings';
import HotjarService from '../../services/HotjarService/HotjarService';
import {ControlButton, TscButtonType} from '@techsmith/tsc-cloud-style-guide';
import Themeable from '../../types/Themeable';

export default class BuyNowModal extends React.Component<BuyNowModalProps, {}> {
   constructor(props: BuyNowModalProps) {
      super(props);
      autoBind(this);
   }

   onClose() {
      HotjarService.buyNowModalClosed();
      this.props.onClose();
   }

   render() {
      return (
         <ValuePropModal bannerText={Strings.labels.buyNowModal.bannerText}
                         bodyText={Strings.labels.buyNowModal.bodyHeader}
                         bodySubText={Strings.labels.buyNowModal.bodyText}
                         benefitList={[]}
                         themeName={this.props.themeName}
                         testId="buy-now-modal"
                         onClose={this.onClose}>
            <ControlButton buttonType={TscButtonType.primary}
                           label={Strings.labels.buyNowModal.prompt}
                           href={this.props.storeUrl}
                           themeName={this.props.themeName}
                           testId="buy-now-confirm-button"
                           isFullWidth={true} />
         </ValuePropModal>
      );
   }
}

export interface BuyNowModalProps extends Themeable {
   storeUrl: string;
   onClose(): void;
}
